export default __webpack_public_path__ + "static/media/slash2.58e5a271.svg";